enum BaseMap {
    Streets = "Streets",
    SatelliteMapbox = "SatelliteMapbox",
    SatelliteGoogle = "SatelliteGoogle",
    SatelliteArcGIS = "SatelliteArcGIS",
    SatelliteBing = "SatelliteBing",
    SatelliteNAIP = "SatelliteNAIP",
    HybridMapbox = "HybridMapbox",
}

export default BaseMap;